var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34175 7.24744C4.75739 6.88375 5.38915 6.92587 5.75283 7.34151L12.0003 14.4814L18.2477 7.34151C18.6114 6.92587 19.2431 6.88375 19.6588 7.24744C20.0744 7.61112 20.1165 8.24288 19.7528 8.65852L13.1291 16.2285C12.5315 16.9115 11.469 16.9115 10.8714 16.2285L4.24768 8.65852C3.884 8.24288 3.92612 7.61112 4.34175 7.24744Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34175 7.24744C4.75739 6.88375 5.38915 6.92587 5.75283 7.34151L12.0003 14.4814L18.2477 7.34151C18.6114 6.92587 19.2431 6.88375 19.6588 7.24744C20.0744 7.61112 20.1165 8.24288 19.7528 8.65852L13.1291 16.2285C12.5315 16.9115 11.469 16.9115 10.8714 16.2285L4.24768 8.65852C3.884 8.24288 3.92612 7.61112 4.34175 7.24744Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34175 7.24744C4.75739 6.88375 5.38915 6.92587 5.75283 7.34151L12.0003 14.4814L18.2477 7.34151C18.6114 6.92587 19.2431 6.88375 19.6588 7.24744C20.0744 7.61112 20.1165 8.24288 19.7528 8.65852L13.1291 16.2285C12.5315 16.9115 11.469 16.9115 10.8714 16.2285L4.24768 8.65852C3.884 8.24288 3.92612 7.61112 4.34175 7.24744Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.60a8f5d1692304f38fe8517428f142ed.svg";
export { ForwardRef as ReactComponent };